module.exports = __webpack_public_path__ + "static/media/V5.e45dfce7.png";